interface Props {
  className?: string;
}

export default function WhatsAppIcon({ className = 'h-4 w-4' }: Props) {
  return (
    <svg aria-hidden="true" className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.04 2c-5.52 0-10 4.48-10 10 0 1.77.46 3.45 1.32 4.95L2 22l5.2-1.34c1.44.79 3.07 1.2 4.84 1.2h.01c5.52 0 10-4.48 10-10S17.56 2 12.04 2Zm5.86 14.32c-.25.7-1.24 1.29-2.02 1.46-.55.11-1.26.2-3.65-.78-2.85-1.18-4.68-4.08-4.82-4.27-.14-.19-1.16-1.55-1.16-2.95 0-1.4.73-2.09 1-2.37.24-.27.53-.34.71-.34h.5c.16 0 .38-.02.58.45.24.58.83 2.02.9 2.17.07.15.11.32.02.51-.09.19-.14.31-.28.47-.14.16-.29.36-.42.48-.14.13-.28.28-.12.55.16.27.71 1.19 1.53 1.94 1.05.95 1.94 1.25 2.21 1.4.27.15.43.13.6-.05.16-.18.68-.8.87-1.08.18-.27.36-.22.6-.13.25.09 1.57.75 1.84.89.27.14.45.2.51.32.07.12.07.66-.18 1.35Z" />
    </svg>
  );
}
